// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

:root {
  --mi-primary: #007cc2;
  --mi-secondary: #ffd51d;
  --mi-link: #0c51a1;
  --tx-primary: #faa61a;
  --tx-secondary: #002776;
  --nj-primary: #ffd100;
  --nj-secondary: #046a38;
  --wv-primary: #061638;
  --wv-secondary: #d70040;
}

code {
  font-family:
    source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;wEAEsE;EACtE,mCAAmC;EACnC,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE;sEACoE;AACtE","sourcesContent":["body {\r\n  margin: 0;\r\n  font-family:\r\n    -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',\r\n    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  height: 100%;\r\n}\r\n\r\n:root {\r\n  --mi-primary: #007cc2;\r\n  --mi-secondary: #ffd51d;\r\n  --mi-link: #0c51a1;\r\n  --tx-primary: #faa61a;\r\n  --tx-secondary: #002776;\r\n  --nj-primary: #ffd100;\r\n  --nj-secondary: #046a38;\r\n  --wv-primary: #061638;\r\n  --wv-secondary: #d70040;\r\n}\r\n\r\ncode {\r\n  font-family:\r\n    source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
